'use client';

import { useTranslations } from 'next-intl';
import { Button } from '~/components/Button';
import { Heading } from '~/components/Heading';
import styles from './error.module.css';

const TripOverviewError = ({ reset }: Readonly<{ reset: () => void }>) => {
  const t = useTranslations('journey');

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.title}>
          <Heading level="h1" variant="heading-xl">
            {t('overview_error_heading')}
          </Heading>
        </div>
        <p className={styles.description}>{t('overview_error_description')}</p>
        <div className={styles.buttonContainer}>
          <Button onPress={reset}>{t('overview_error_retry')}</Button>
        </div>
      </div>
    </div>
  );
};

export default TripOverviewError;
